'use strict';

angular.module('AcaApp').factory('SecurityService',
[
  'AuthResource',
  function(AuthResource){
    return {
      getSecurityQuestions: function(){
        var rpcConfig = {method: '_GetSecurityQuestions', params: []};
        return AuthResource.executeRpc(rpcConfig).$promise;
      },
      forgotPassword: function(user){
        var rpcConfig = {method: '_ForgotPassword', params: ''};
        rpcConfig.params = [user.email];
        return AuthResource.executeRpc(rpcConfig).$promise;
      },
      findUserSecurityQuestion: function(token){
        var rpcConfig = {method: '_FindUserSecurityQuestion', params: ''};
        rpcConfig.params = [token];
        return AuthResource.executeRpc(rpcConfig).$promise;
      },
      validateSecurityAnswer: function(token, answerObject){
        var rpcConfig = {method: '_ValidateSecurityAnswer', params: ''};
        rpcConfig.params = [token, answerObject];
        return AuthResource.executeRpc(rpcConfig).$promise;
      },
      validateToken: function(token, type){
        var rpcConfig = {method: '_ValidateToken', params: ''};
        rpcConfig.params = [token, type];
        return AuthResource.executeRpc(rpcConfig).$promise;
      },
      changePassword: function(newPassword){
        var rpcConfig = {method: 'changePassword', params: ''};
        rpcConfig.params = [newPassword];
        return AuthResource.executeRpc(rpcConfig).$promise;
      },
      changePasswordByAdmin: function(userName){
        var rpcConfig = {method: 'ChangePasswordByAdmin', params: ''};
        rpcConfig.params = [userName];
        return AuthResource.executeRpc(rpcConfig).$promise;
      },
      updateUserEulaHash: function(eulaHash){
        var rpcConfig = {method: 'updateUserEulaHash', params: ''};
        rpcConfig.params = [eulaHash];
        return AuthResource.executeRpc(rpcConfig).$promise;
      },
      getEulaData: function(eulaHash){
        var rpcConfig = {method: 'GetEulaData', params: []};
        return AuthResource.executeRpc(rpcConfig).$promise;
      }
    };
  }
]);
